export type SearchableTokens = {searchTokens: string[]};
export const getSearchTokens = (fieldvalues: (string | undefined)[]) => {
  return fieldvalues
    .join(' ')
    .replaceAll(/[^\w\s]/g, '')
    .toLowerCase()
    .split(/\s+/)
    .map(s => s.trim());
};
